import { createSlice } from "@reduxjs/toolkit";

import { SensorTypeObject } from "../../types";

/***************************************************************************** */
export interface MeasurementTypesState {
  sensorTypes: Array<SensorTypeObject> | [];
}

const initialState: MeasurementTypesState = {
  sensorTypes: []
};

export const deviceTypesSlice = createSlice({
  name: "DeviceTypes",
  initialState,
  reducers: {}
});
/***************************************************************************** */

/***************************************************************************** */
// eslint-disable-next-line no-empty-pattern
export const {} = deviceTypesSlice.actions;

export default deviceTypesSlice.reducer;
